import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../core/authentication/authentication.service';
import { isPlatformBrowser } from '@angular/common';
import { CommonApi } from '../../core/http/common.api.service';
import { LanguageConstant } from '../../../app/shared/constants/language-constant';

@Component({
  selector: 'app-header-landing-page',
  templateUrl: './header-landing-page.component.html'
})
export class HeaderLandingPageComponent implements OnInit {
  languages = LanguageConstant.GetAllAsDataItem();
  selectedLangName: any;
  isBrowser;
  isPreRegistration = false;
  constructor(
    private translate: TranslateService,
    private router: Router,
    private authenticationService: AuthenticationService,
    private commonApi: CommonApi,
    @Inject(PLATFORM_ID) private platformId) {
      this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnInit() {
    if (this.isBrowser) {
      let currentLang = localStorage.getItem('language');
      if(currentLang != null && currentLang != '') {
        this.selectedLangName = this.languages.find(c => c.value == currentLang).display;
      } else {
        this.selectedLangName = this.languages[0].display;
      }
      this.commonApi.getAppConfiguration().subscribe((result: any) => {
        this.isPreRegistration = result.isPreRegistration;
      })
    }
  }

  onLanguageChange(selectedLang) {
    if (selectedLang) {
      this.selectedLangName = this.languages.find(x => x.value === selectedLang).display;
      this.translate.use(selectedLang);
      localStorage.setItem('language', selectedLang);
    }
  }

  goLogin() {
    this.authenticationService.login();
  }
  goRegister() {
    this.authenticationService.register();
  }
}
